/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Appointment/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import Actions from './Actions/index'
import AddNoteAction from './AddNoteAction/index'
import AssistantAndProvider from './AssistantAndProvider/index'
import Colors from './Colors/index'
import Expanded from './Expanded/index'
import Hour from './Hour/index'
import Indicator from './Indicator/index'
import Location from './Location/index'
import Name from './Name/index'
import NextControl from './NextControl/index'
import React from 'react'
import Reference from './Reference/index'
import Status from './Status/index'
import Time from './Time/index'
import Title from './Title/index'
import styles from './view.module.css'
import useIsMedia from 'Simple/hooks/useIsMedia'



/** @type {import('Simple/types.js').View} */
export default function Appointment({
  children,
  viewPath = "/DesignSystem/TimelineEvent/Appointment",
  onMouseEnter,
  onMouseLeave,
  isHoveredManual,
  backgroundColor
  
}) {
  let isMedia = useIsMedia()
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let dtColorsTransparent = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.transparent'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let dtColorsGreen400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.400'
        })
let eventAppointmentBookingStateValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'appointment.booking.state',
})
let constantData = 'SEATED'
let aggregateData = fromAggregate.equals(eventAppointmentBookingStateValueData, constantData)
let eventAppointmentUnplannedValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'appointment.unplanned',
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsGreen100 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.100'
        })
let dtColorsBlue600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.blue.600'
        })
let dtColorsNeutral700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.700'
        })
  return (<React.Fragment
>
<Title
  viewPath={`${viewPath}/Title`}
/>
<div
  data-testid="Appointment.Horizontal"
  data-view-path={viewPath}
 style={{'--bc-1-dUIJ5': dtColorsTransparent,'--mt-3-dUIJ5': flow.has(fromFlow.normalizePath(viewPath, 'Expanded/Content')) ? typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM : typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--mb-4-dUIJ5': flow.has(fromFlow.normalizePath(viewPath, 'Expanded/Content')) ? typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS : "0px",'--mw-2-dUIJ5': isMedia.mobile ? "100%" : "990px"}}
 className={`views-block ${styles.Horizontal}`}
>
<Reference
  viewPath={`${viewPath}/Reference`}
/>
<div
  data-testid="Appointment.Vertical"
  data-view-path={viewPath}
 style={{'--mt-3-dUIJ5': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical}`}
>
<Time
  viewPath={`${viewPath}/Time`}
/>
</div>
<Indicator
  viewPath={`${viewPath}/Indicator`}
/>
<div
  data-testid="Appointment.Vertical:1"
  data-view-path={viewPath}
 onMouseOver={onMouseEnter}
 onMouseLeave={onMouseLeave}
 style={{'--btlr-11-dUIJ5': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-12-dUIJ5': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bblr-13-dUIJ5': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-14-dUIJ5': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--sb-8-dUIJ5': isHoveredManual ? "6px" : flow.has(fromFlow.normalizePath(viewPath, 'Expanded/Content')) ? "6px" : "1px",'--sc-10-dUIJ5': isHoveredManual ? "rgba(222, 226, 230, 1)" : flow.has(fromFlow.normalizePath(viewPath, 'Expanded/Content')) ? "rgba(222, 226, 230, 1)" : "rgba(222, 226, 230, 1)",'--soy-9-dUIJ5': isHoveredManual ? "1px" : flow.has(fromFlow.normalizePath(viewPath, 'Expanded/Content')) ? "1px" : "1px",'--bc-5-dUIJ5': flow.has(fromFlow.normalizePath(viewPath, 'Expanded/Content')) ? dtColorsGreen400 : dtColorsNeutral400,'--ml-6-dUIJ5': flow.has(fromFlow.normalizePath(viewPath, 'Expanded/Content')) ? "0px" : typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--mr-7-dUIJ5': flow.has(fromFlow.normalizePath(viewPath, 'Expanded/Content')) ? "0px" : typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical1}`}
>
<div
  data-testid="Appointment.Horizontal:1"
  data-view-path={viewPath}
 style={{'--pt-15-dUIJ5': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pb-16-dUIJ5': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btlr-11-dUIJ5': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-12-dUIJ5': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bc-1-dUIJ5': flow.has(fromFlow.normalizePath(viewPath, 'Expanded/Content')) ? dtColorsGreen100 : backgroundColor,'--bblr-13-dUIJ5': flow.has(fromFlow.normalizePath(viewPath, 'Expanded/Content')) ? "0px" : aggregateData ? typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs : eventAppointmentUnplannedValueData ? typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs : typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-14-dUIJ5': flow.has(fromFlow.normalizePath(viewPath, 'Expanded/Content')) ? "0px" : aggregateData ? typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs : eventAppointmentUnplannedValueData ? typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs : typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal1}`}
>
<div
  data-testid="Appointment.Horizontal:2"
  data-view-path={viewPath}
 onClick={flow.has(fromFlow.normalizePath(viewPath, 'Expanded/Content')) ? () => setFlowTo(fromFlow.normalizePath(viewPath, 'Expanded/No')) : () => setFlowTo(fromFlow.normalizePath(viewPath, 'Expanded/Content'))}
 className={`views-block ${styles.Horizontal2}`}
>
<div
  data-testid="Appointment.Horizontal:3"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal3}`}
>
<div
  data-testid="Appointment.Horizontal:4"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal4}`}
>
<Colors
  viewPath={`${viewPath}/Colors`}
/>
</div>
<div
  data-testid="Appointment.Vertical:2"
  data-view-path={viewPath}
 style={{'--ml-6-dUIJ5': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical2}`}
>
<Name
  viewPath={`${viewPath}/Name`}
/>
<div
  data-testid="Appointment.Horizontal:5"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal5}`}
>
<Hour
  viewPath={`${viewPath}/Hour`}
/>
<Location
  viewPath={`${viewPath}/Location`}
/>
</div>
<Status
  viewPath={`${viewPath}/Status`}
/>
</div>
</div>
<AssistantAndProvider
  viewPath={`${viewPath}/AssistantAndProvider`}
/>
</div>
<NextControl
  viewPath={`${viewPath}/NextControl`}
/>
<AddNoteAction
  viewPath={`${viewPath}/AddNoteAction`}
/>
<Actions
  viewPath={`${viewPath}/Actions`}
/>
</div>
<Expanded
  viewPath={`${viewPath}/Expanded`}
/>
</div>
</div>
{children}
</React.Fragment>)
}